import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styles from './style.css';

const UpgradeToMokaposModal = props => {
  const { isShowing, onOkButtonClick } = props;

  return (
    <Modal show={isShowing} className={`moka-pay-modal`}>
      <Modal.Body className={`${styles.body}`}>
        <center>
          <div
            className={`fa fa-times ${styles.close}`}
            onClick={onOkButtonClick}
          />
          <div className={`${styles.head}`}>
            <h2>Upgrade to Moka POS</h2>
            <p>
              Upgrading to Moka POS will allow you to simplify and increase
              efficiency of selling.
            </p>
          </div>
          <div className={`${styles.video}`}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/BlEyTOq8_uE"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </center>

        <div className={`${styles.benefit}`}>
          <h3>Why should you upgrade to Moka POS?</h3>
          <ul className={`${styles.feature}`}>
            <li>
              Unlock features
              <div className={`row ${styles.row}`}>
                <div className="col-md-6">
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  Advanced Sales Report
                </div>
                <div className="col-md-6">
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  Customers
                </div>
                <div className="col-md-6">
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  Advanced Item Library
                </div>
                <div className="col-md-6">
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  <a
                    href="https://mokapos.com/features/loyalty_program"
                    target="_blank"
                  >
                    Loyalty Program
                  </a>
                </div>
                <div className="col-md-6">
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  <a href="https://mokapos.com/ingredient" target="_blank">
                    Ingredient
                  </a>
                </div>
                <div className="col-md-6">
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  Employee Management
                </div>
                <div className="col-md-6">
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  Inventory
                </div>
                <div className="col-md-6">
                  <i className="fa fa-check-circle-o" aria-hidden="true" />
                  <a
                    href="https://mokapos.com/table-management"
                    target="_blank"
                  >
                    Table management
                  </a>
                </div>
              </div>
            </li>
            <li>Easily Manage your store</li>
            <li>Take control of unlimited selling experience</li>
          </ul>
          <center className={`${styles.footer}`}>
            <p className={`${styles.about}`}>
              <a href="https://mokapos.com/pos" target="_blank">
                Learn more about Moka POS
              </a>
            </p>
            <p className={`${styles.upgrade}`}>
              Contact support@mokapos.com
              <br />
              to Upgrade to Moka POS
            </p>
          </center>
        </div>
      </Modal.Body>
    </Modal>
  );
};

UpgradeToMokaposModal.propTypes = {
  isShowing: PropTypes.bool,
  onOkButtonClick: PropTypes.func,
};

UpgradeToMokaposModal.defaultProps = {
  isShowing: false,
  onOkButtonClick: () => {},
};

export default UpgradeToMokaposModal;
